/* globals moment */
(function () {
    'use strict';

    angular
        .module('app')
        .constant('moment', moment);
})();